<template>
  <div class="home">
    <h2>App Info</h2>
    <!-- Filtering -->
    <b-row>
      <b-col md="12" class="my-1">
        <b-form-group label-cols-sm="1" label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input
              v-model="filter.email"
              placeholder="by Email"
              @keypress.enter="forceFilter"
            />
            <b-form-input
              v-model="filter.login"
              placeholder="by Login"
              @keypress.enter="forceFilter"
            />
            <b-form-input
              v-model="filter.appInstallId"
              placeholder="by appInstallId"
              @keypress.enter="forceFilter"
            />

            <b-input-group-append>
              <b-button
                :disabled="
                  !filter.appInstallId && !filter.login && !filter.email
                "
                @click="
                  filter = {};
                  forceFilter();
                "
                >Clear</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-container fluid>
      <b-row>
        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="2" label="Sort" class="mb-0">
            <b-input-group>
              <b-form-select v-model="sortBy" :options="sortOptions">
                <option slot="first" :value="null">-- none --</option>
              </b-form-select>
              <b-form-select
                :disabled="!sortBy"
                v-model="sortDesc"
                slot="append"
              >
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-row>
        <b-col>
          <b-button
            @click="removeAllItems()"
            size="sm"
            variant="danger"
            class="m-1 ml-3 float-right"
            >Remove All Items</b-button
          >
        </b-col>
      </b-row>
      <b-table
        show-empty
        small
        hover
        stacked="md"
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @filtered="onFiltered"
        ref="appInfoTable"
        class="appInfoTable"
      >
        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            variant="danger"
            class="m-1 ml-3"
            title="Delete AppInfo"
            @click="
              removeAppInfo({
                target: $event.target,
                appInfo: row.item
              })
            "
            >X</b-button
          >
          <b-button
            size="sm"
            variant="success"
            class="m-1 ml-3"
            title="Copy appInstallId to clipboard"
            @click="copyToClipboard(row.item)"
            >⎘</b-button
          >
        </template>
        <template v-slot:cell(active)="row">
          {{ row.value ? 'Yes' : 'No' }}
        </template>

        <template v-slot:row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">
                {{ key }}: {{ value }}
              </li>
            </ul>
          </b-card>
        </template>
      </b-table>

      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable no-magic-numbers */

export default {
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 100, 500],
      sortBy: null,
      sortDesc: false,
      filter: {
        email: '',
        login: '',
        appInstallId: ''
      }
    };
  },

  computed: {
    formIsActive: {
      get: function() {
        return !!this.form.active;
      },
      set: function(newValue) {
        this.form.active = newValue;
      }
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    fields() {
      return [
        {
          key: 'id',
          label: 'id',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'login',
          label: 'Login',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'appInstallId',
          label: 'appInstallId',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'buildDate',
          label: 'buildDate',
          sortable: false,
          class: 'text-center'
        },
        {
          key: 'buildHash',
          label: 'buildHash',
          sortable: false,
          class: 'text-center'
        },
        {
          key: 'version',
          label: 'version',
          sortable: false,
          class: 'text-center'
        },
        {
          key: 'whitelabel',
          label: 'Whitelabel',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'platform',
          label: 'Platform',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'userId',
          label: 'UserId',
          sortable: true,
          class: 'text-center'
        },
        { key: 'actions', label: 'Actions' }
      ];
    },
    totalRows() {
      return this.$store.state.appInfo.count;
    }
  },
  methods: {
    copyToClipboard(item) {
      this.$copyText(item.appInstallId);
    },
    removeAllItems() {
      if (confirm('Sure you want to delete them all?')) {
        const promise = this.$store.dispatch('removeAllAppInfo');

        // Must return a promise that resolves to an array of items
        return promise.then(() => {
          this.$refs.appInfoTable.refresh();
        });
      }
    },
    removeAppInfo({ appInfo = null }) {
      if (!appInfo) {
        return;
      }
      if (confirm('Delete this item?')) {
        const promise = this.$store.dispatch('removeAppInfo', appInfo.id);

        // Must return a promise that resolves to an array of items
        return promise.then(() => {
          this.$refs.appInfoTable.refresh();
        });
      }
    },
    forceFilter() {
      this.onFiltered();
      this.$refs.appInfoTable.refresh();
    },
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.currentPage = 1;
    },
    items(ctx) {
      const currentFilter = Object.keys(this.filter).reduce(
        (acc, curr) =>
          this.filter[curr] ? { ...acc, [curr]: this.filter[curr] } : acc,
        {}
      );
      const promise = this.$store.dispatch('getAppInfo', {
        ctx,
        filter: currentFilter
      });

      // Must return a promise that resolves to an array of items
      return promise.then(() => {
        const items = this.$store.state.appInfo.rows;
        // Must return an array of items or an empty array if an error occurred
        return items || [];
      });
    }
  }
};
</script>
<style scoped type="text/scss">
.block {
  border-bottom: #dadada 1px solid;
  padding-bottom: 1em;
  margin-bottom: 3em;
}
.container {
  max-width: none;
}
.appInfoTable {
  font-size: 0.8rem;
}
.btn {
  font-size: 0.8rem;
}

td[data-label='Actions'] {
  white-space: nowrap;
}
</style>
